<template>
  <div class="row items-center cursor-pointer">
    <img :src="require('@/assets/meitav-dash/combined-logo.svg')" @click="openWebsite" :width="120" height="20">
  </div>
</template>

<script>

export default {
  name: 'CombinedLogo',
  methods: {
    openWebsite() {
      window.open('https://www.riseup.co.il', '_blank');
    },
  },
};
</script>
